export const TeamLiveReportsRoutes = [{
        "url": "/time-card-edits-report",
        "name": "appLayout.schedule.reports.time-card-edits-report",
        "showGlobalSearch": true,
        "loginRequired": true,
        "type": "frontend",
        "views": {
            "reports-body": {
                templateUrl: "../hmodules/team-live/reports/time-card-edits-report/controllers/time-card-edits-report/time-card-edits-report.html",
                controller: "TimeCardEditsReportController",
                controllerAs: "$ctrl"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Time Card Edits Report | Harri"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@hmodules/team-live/reports/team-live_reports.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ]
    }];
//# sourceMappingURL=team-live_reports.routes.js.map